module.exports = __webpack_public_path__ + "img/Home-paintlabel.076be548.jpg";